import { render, staticRenderFns } from "./courseSubjectComponent.vue?vue&type=template&id=af5869c6&"
import script from "./courseSubjectComponent.vue?vue&type=script&lang=js&"
export * from "./courseSubjectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports